import { createAsyncAction } from 'typesafe-actions';
import { RiskRecord } from '@rootCommon/types/cancerRisk';

export const fetchRiskRecord = createAsyncAction(
  'FETCH_RISK_RECORD_REQUEST',
  'FETCH_RISK_RECORD_SUCCESS',
  'FETCH_RISK_RECORD_FAILURE',
)<undefined, RiskRecord, Error>();

export const updateRiskRecord = createAsyncAction(
  'UPDATE_RISK_RECORD_REQUEST',
  'UPDATE_RISK_RECORD_SUCCESS',
  'UPDATE_RISK_RECORD_FAILURE',
)<RiskRecord, RiskRecord, Error>();
